import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';

import useSession from '../hooks/useSession';
import { postWithAuth } from "../utils/api";

function Play() {
  const navigate = useNavigate();
  const location = useLocation();
  const { session } = useSession();

  let [failedState, setFailedState] = useState(false);

  useEffect(() => {
    const pullData = async (session) => {
      const urlParams = new URLSearchParams(location.search);
      const claimKey = urlParams.get('claim');
      const stationId = urlParams.get('station');

      try {
        const result = await postWithAuth(`/stations/${stationId}/claim`, session.authToken, { claimKey });
        const data = await result.json();
        if (result.status !== 200) {
          throw new Error(data.error || 'Failed to claim station');
        }
        navigate('/stats', { replace: true });
        return;
      } catch (error) {
        console.error(error);
        setFailedState(true);
        return;
      }
    };

    if (!session) {
      navigate(`/${location.search}`, { replace: true });  // Redirect to home with params if no session
    } else {
      pullData(session);
    }
  }, [session, navigate, location.search]);

  if (failedState) {
    return <div>Unable to claim. Please try again.</div>
  }

  return (
    <div>checking...</div>
  );
}

export default Play;